import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogActions, Button, Checkbox, FormControlLabel } from '@material-ui/core'
import MultipleMultimedia from '../QuestionForms/MultipleMedia/MultipleMultimedia'
import ShortAnswer from '../QuestionForms/ShortAnswer/ShortAnswer'
import { ValidatorContext, QuestionItemContext } from 'containers/Examination/ExaminationContext'
import { updateQuestion } from 'containers/Examination/ExaminationService'

const EditQuestion = ({modalState, onClose, question}) => {
  const [open, setOpen] = useState(false)
  const type =  question.type
  const [validationError, setValidationError] = useState({})
  const [updatedQuestion, setUpdatedQuestion] = useState(question)
  const [bonus, setBonus] = useState(question.bonus)

  const handleClose = (refreshQuestions = false) => {
    setOpen(false)
    onClose(refreshQuestions)
  }

  const saveUpdates = async () => {
    setValidationError({})

    const response = await updateQuestion(question.examination_id, question.id, updatedQuestion)

    if (!response.success && response.error_type === "failed_validation") {
      setValidationError(response.errors)
      return
    }

    handleClose(true)
  }

  useEffect(() => {
    if (modalState !== "closed") {
      setOpen(true)
    }
  }, [modalState])

  useEffect(() => {
    setUpdatedQuestion((oldQuestion) => {
      oldQuestion.bonus = bonus
      return oldQuestion
    })
  }, [bonus])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      disableBackdropClick={true}
    >
      <DialogContent>

        <QuestionItemContext.Provider value={question}>
          <ValidatorContext.Provider value={{validationError}}>
            {type === "MULTIPLE_CHOICES" && <MultipleMultimedia onChange={(updatedQuestion) => setUpdatedQuestion(updatedQuestion)} />}
            {type === "SHORT_ANSWER" && <ShortAnswer onChange={(questionObject) => setUpdatedQuestion(questionObject)} />}
          </ValidatorContext.Provider>
        </QuestionItemContext.Provider>

        <DialogActions>
            <FormControlLabel
              control={
                <Checkbox
                  checked={bonus}
                  onChange={(e) => setBonus(e.target.checked)}
                  name="checked"
                  color="primary"
                />
              }
              label="Make this a bonus question"
              color="primary"
              style={{marginRight: 'auto'}}
            />
          <Button onClick={handleClose} color="primary">
            Discard Changes
          </Button>
          <Button onClick={saveUpdates} color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default EditQuestion